import { useCallback, useEffect, useState } from "react";
import LoginPage from "./pages/LoginPage";
import TilesPage from "./pages/TilesPage";
import { fetchMe, type MeResponse } from "./api";

type ViewState =
  | { status: "loading" }
  | { status: "loggedOut" }
  | { status: "loggedIn"; me: MeResponse };

export default function App() {
  const [view, setView] = useState<ViewState>({ status: "loading" });

  const loadMe = useCallback(async () => {
    try {
      const me = await fetchMe();
      setView({ status: "loggedIn", me });
    } catch {
      setView({ status: "loggedOut" });
    }
  }, []);

  useEffect(() => {
    void loadMe();
  }, [loadMe]);

  if (view.status === "loading") {
    return <div className="page-center">Lade...</div>;
  }

  if (view.status === "loggedOut") {
    return <LoginPage onLoginSuccess={() => void loadMe()} />;
  }

  return <TilesPage me={view.me} onLoggedOut={() => setView({ status: "loggedOut" })} />;
}
